import type { FindUserReservationHotelReservation } from "@/app/lib/types/codegen";
import { useTranslations } from "use-intl";
import { ReservationPaymentDetails } from "./ReservationPaymentDetails";
import { ReservationNextSteps } from "./ReservationNextSteps";
import { ReservationDocumentList } from "../ReservationDocumentList";
import { BookedHotelCard } from "../hotels-list/BookedHotelCard";
import { Image } from "../Image";

type Props = {
  reservation: FindUserReservationHotelReservation;
};

export const MyHotel = ({ reservation }: Props) => {
  const t = useTranslations();

  return (
    <>
      <BookedHotelCard reservation={reservation.externalReservation} />

      <section className="section-card mt-2 mb-4 flex w-full items-center justify-between gap-4">
        <span className="section-title mb-0">
          {t("reservations.bookingNumber")}
        </span>
        <span className="text-base font-semibold text-text-title">
          {reservation.externalReservation.reference.external}
        </span>
      </section>

      <ReservationDocumentList reservationId={reservation.reservationId} />

      <section>
        <h3 className="section-title mt-4">{t("reservations.roomDetails")}</h3>
        <ul className="section-card flex w-full flex-col gap-4">
          {reservation.externalReservation.rooms.map((room) => (
            <li
              key={room.id}
              className="flex justify-between gap-4 rounded-2xl bg-[#F3F4F7] p-3 text-sm font-medium"
            >
              <div>
                {[room.name, room.board, room.info].filter(Boolean).join(" - ")}
              </div>

              {reservation.externalReservation.hotel.mainImageUrl ? (
                <div className="relative h-[48px] w-[60px] overflow-clip rounded-lg">
                  <Image
                    className="h-full w-full object-cover"
                    src={reservation.externalReservation.hotel.mainImageUrl}
                    alt={reservation.externalReservation.hotel.name}
                    width={60}
                    height={48}
                  />
                </div>
              ) : null}
            </li>
          ))}
        </ul>
      </section>

      <ReservationPaymentDetails reservation={reservation} />
      <ReservationNextSteps type="hotel" />
    </>
  );
};
